// This file should only contain action type constants.

export const SET_ITEMS = 'SET_ITEMS';
export const ADD_ITEM = 'ADD_ITEM';
export const REMOVE_ITEM = 'REMOVE_ITEM';
export const SET_SIMPLE_VIEW_ATTRIBUTES = 'SET_SIMPLE_VIEW_ATTRIBUTES';
export const SET_LEAD_GATE = 'SET_LEAD_GATE';
export const SET_SITE_CONFIG_PROPERTIES = 'SET_SITE_CONFIG_PROPERTIES';
